namespace $.$$ {

	export class $shm_hitalama_text_list extends $.$shm_hitalama_text_list {
		@ $mol_mem
		view_window( next?: [ number, number ] ): [ number, number ] { return this.$.$shm_hitalama_text_window( this, next ) }

		override sub_visible() { return this.$.$shm_list_sub_visible.call( this ) }

		override rows() {
			return super.rows().map( ( row, index )=> this.flow_tokens()[ index ].name === 'code-indent'
				? this.Continuation( index )
				: row,
			)
		}

		@ $mol_mem_key
		override Link( id: any ) {
			const link = new this.$.$shm_hitalama_text_link()
			link.uri = ()=> this.link_uri( id )
			link.content = ()=> this.line_content( id )
			link.favicon = ()=> this.favicon()
			return link
		}

		@ $mol_mem_key
		override Link_http( id: any ) {
			const link = new this.$.$shm_hitalama_text_link()
			link.uri = ()=> this.link_uri( id )
			link.content = ()=> [ this.link_uri( id ) ]
			link.favicon = ()=> this.favicon()
			return link
		}

	}

}
